import React, { useContext } from 'react'
import { SubStdSelContext } from "../../../../SubStdSelContext";
import { Link, NavLink } from 'react-router-dom';
import { connect } from "react-redux";
import { useLocation } from 'react-router-dom';


const mapStateToProps = (state) => ({
    inc: state.redres,
    dec: state.redres1,
    ovr: state.redres2,
});
function AddClassMaterial({ event, inc, dec }) {
    const { secSelectedOption, stdSelectedOption } = useContext(SubStdSelContext);
    const standardsName = localStorage.getItem('stdSelectionName')
    const sectionName = localStorage.getItem('secSelectionName')
    return (
        <div>
            {
                //Here I added logic for check event?.Supplement_id is present or not
                event?.Supplement_id ? <NavLink
                    className="link"
                    to={`/liveSession`}
                    state={{ supplement_id: event.Supplement_id, standard_id: stdSelectedOption, section_id: secSelectedOption, lecture_id: event.Id, scheduled_date: event.StartTime, standardsName: standardsName, sectionName: sectionName }}
                >
                    <div id="card_body_new" onClick={() => {
                        localStorage.setItem("liveSession", JSON.stringify(event));
                        let obj = {
                            standard_id: inc.id,
                            section_id: dec.id,
                        }
                        localStorage.setItem("std", JSON.stringify(obj));
                        localStorage.setItem("from", "DCM")
                    }}>
                        {!(event.LactureType === "general_lacture") && <button type="button" id='PopUpBtn_Sanskrt' class="btn btn">View/Edit Summary</button>}
                    </div>
                    {/* Add logic for redirect page on livesession */}
                </NavLink> :
                    <NavLink
                        className="link"
                        to={`/liveSession`}
                        state={{ supplement_id: event.Supplement_id, standard_id: stdSelectedOption, section_id: secSelectedOption, lecture_id: event.Id, scheduled_date: event.StartTime, standardsName: standardsName, sectionName: sectionName }}
                    >
                        <div id="card_body_new" onClick={() => {
                            localStorage.setItem("liveSession", JSON.stringify(event));
                            let obj = {
                                standard_id: inc.id,
                                standardName: inc.name,
                                section_id: dec.id,
                                sectionName: dec.name
                            }
                            localStorage.setItem("std", JSON.stringify(obj));
                            localStorage.setItem("from", "DCM")
                        }}>
                            {!(event.LactureType === "general_lacture") && <button type="button" id='PopUpBtn_Sanskrt' class="btn btn">Add Class Material</button>}
                        </div>
                    </NavLink>
            }

        </div>
    )
}
export default connect(mapStateToProps)(AddClassMaterial);
